// extracted by mini-css-extract-plugin
module.exports = {"addQuickBooksDesktopBlock":"addQuickBooksDesktopBlock__VVLT0","title":"title__5RuQQ","text":"text__ybx5-","buttonContainer":"buttonContainer__kf8wP"};